/* eslint-disable max-lines-per-function */
import React, { useCallback, useEffect } from 'react';
import { Card, Tab } from 'react-bootstrap';

import { useCookies } from '../../../common/hooks/useCookies';
import { useSpdCore } from '../../../common/hooks/useSpdCore';
import { useNavigation } from '../../../common/navigation';
import { TabsHistory } from '../../../app/components/TabsHistory';

import { ExamsActiveView } from './ExamsActiveView';
import { ExamsInActiveView } from './ExamsInActiveView';

export const ExamsView: React.FC = () => {
  const spd = useSpdCore();
  const nav = useNavigation();
  const cookies = useCookies();

  useEffect(() => {
    if (cookies.activeMonitor !== '') {
      cookies.setActiveMonitor('');
    }
  }, [cookies]);

  const handleClick = async (id: string) => {
    void nav.examTests(id);
  };

  const handleSelect = (key: string | null) => {
    cookies.setActiveTabMonitor(key as string);
  };

  const getDataWithoutJudgment = useCallback(
    (
      pageSize: number,
      pageNumber: number,
      orderBy?: string,
      orderDirection?: string,
      filterText?: string,
      filterColumns?: string,
    ) =>
      spd.exams.getWithoutJudgmentByPortion(
        pageSize,
        pageNumber,
        orderBy,
        orderDirection,
        filterText,
        filterColumns,
      ),
    [spd.exams],
  );

  const getDataWithoutJudgmentWithoutReferrals = useCallback(
    (
      pageSize: number,
      pageNumber: number,
      orderBy?: string,
      orderDirection?: string,
      filterText?: string,
      filterColumns?: string,
    ) =>
      spd.exams.getWithoutJudgmentWithoutReferralsByPortion(
        pageSize,
        pageNumber,
        orderBy,
        orderDirection,
        filterText,
        filterColumns,
      ),
    [spd.exams],
  );

  const getDataActive = useCallback(
    (
      pageSize: number,
      pageNumber: number,
      orderBy?: string,
      orderDirection?: string,
      filterText?: string,
    ) =>
      spd.exams.getActiveByPortion(
        pageSize,
        pageNumber,
        orderBy,
        orderDirection,
        filterText,
      ),
    [spd.exams],
  );

  // const getDataWithExamined = useCallback(
  //   (
  //     pageSize: number,
  //     pageNumber: number,
  //     orderBy?: string,
  //     orderDirection?: string,
  //     filterText?: string,
  //     filterColumns?: string,
  //   ) =>
  //     spd.exams.getWithExaminedByPortion(
  //       pageSize,
  //       pageNumber,
  //       orderBy,
  //       orderDirection,
  //       filterText,
  //       filterColumns,
  //     ),
  //   [spd.exams],
  // );

  const getDataAll = useCallback(
    (
      pageSize: number,
      pageNumber: number,
      orderBy?: string,
      orderDirection?: string,
      filterText?: string,
      filterColumns?: string,
    ) =>
      spd.exams.getAllByPortion(
        pageSize,
        pageNumber,
        orderBy,
        orderDirection,
        filterText,
        filterColumns,
      ),
    [spd.exams],
  );

  const getDataBlocked = useCallback(
    (
      pageSize: number,
      pageNumber: number,
      orderBy?: string,
      orderDirection?: string,
      filterText?: string,
      filterColumns?: string,
    ) =>
      spd.exams.getBlockedByPortion(
        pageSize,
        pageNumber,
        orderBy,
        orderDirection,
        filterText,
        filterColumns,
      ),
    [spd.exams],
  );

  const getCountBlocked = useCallback(
    (filterText?: string, filterColumns?: string) =>
      spd.exams.getBlockedCount(filterText, filterColumns),
    [spd.exams],
  );

  return (
    <Card>
      <TabsHistory
        activeKey={
          cookies.activeTabMonitor ? cookies.activeTabMonitor : 'activeExams'
        }
        id="exams"
        className="mb-3"
        onAdditionalSelect={handleSelect}
        mountOnEnter={true}
        unmountOnExit={true}
      >
        <Tab
          eventKey="withoutJudgmentExams"
          title="Badania z orzeczeniami do wydania"
          className="m-3"
        >
          <ExamsInActiveView
            getData={getDataWithoutJudgment}
            getCount={spd.exams.getWithoutJudgmentCount}
            onRowClick={handleClick}
            initialOrderColumn="exams.endDate"
            initialOrderDirection="ASC"
            withFilterInColumns={true}
          />
        </Tab>
        <Tab
          eventKey="withoutJudgmentExamsWithoutReferrals"
          title="Orzeczenia do wydania (bez skierowań zewn.)"
          className="m-3"
        >
          <ExamsInActiveView
            getData={getDataWithoutJudgmentWithoutReferrals}
            getCount={spd.exams.getWithoutJudgmentWithoutReferralsCount}
            onRowClick={handleClick}
            initialOrderColumn="exams.endDate"
            initialOrderDirection="ASC"
            withFilterInColumns={true}
          />
        </Tab>
        <Tab eventKey="activeExams" title="Aktywne" className="m-3">
          <ExamsActiveView
            getData={getDataActive}
            getCount={spd.exams.getActiveCount}
            onRowClick={handleClick}
          />
        </Tab>
        {/* <Tab eventKey="examsWithExamined" title="Z badanym" className="m-3">
          <ExamsInActiveView
            getData={getDataWithExamined}
            getCount={spd.exams.getWithExaminedCount}
            onRowClick={handleClick}
            withFilterInColumns={true}
          />
        </Tab> */}
        <Tab eventKey="blockedExams" title="Zablokowane" className="m-3">
          <ExamsInActiveView
            getData={getDataBlocked}
            getCount={getCountBlocked}
            onRowClick={handleClick}
            withFilterInColumns={true}
          />
        </Tab>
        <Tab eventKey="exams" title="Wszystkie badania" className="m-3">
          <ExamsInActiveView
            getData={getDataAll}
            getCount={spd.exams.getAllCount}
            onRowClick={handleClick}
            withFilterInColumns={true}
          />
        </Tab>
      </TabsHistory>
    </Card>
  );
};
